import { IBanner, IReorderBannersDTO } from '@/models/banners.model';

class ReorderBannersDTO implements IReorderBannersDTO {
  items: { id: string; position: number }[];
  constructor(items: IBanner[]) {
    this.items = items.map((banner) => ({ id: banner.id, position: banner.position }));
  }
}

export default ReorderBannersDTO;
